import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const ServiceCompleted = ({ ticketNumber }) => {
  const { t } = useTranslation(['parking'])
  return (
    <React.Fragment>
      <div className="parking-info__section-info-full-row center">
        <div>{t('parking:statusBadge.serviceCompleted.ticketNoHash')}</div>
        <div className="parking-info__section-title">{ticketNumber}</div>
      </div>
      <div className="parking-info__section center darker" style={{ marginTop: '10px' }}>
        <div className="parking-info__section-title">
          {t('parking:statusBadge.serviceCompleted.title')}
        </div>
        <div>{t('parking:statusBadge.serviceCompleted.description')}</div>
      </div>
    </React.Fragment>
  )
}

export default ServiceCompleted

ServiceCompleted.propTypes = {
  ticketNumber: PropTypes.string,
}
